import React from 'react';
import _ from 'lodash';
import { parseAmount } from 'app/utils/parsers';
import history from 'app/routes/history';

import Button from 'app/components/general/Button';
import { CardBody, Card, Input } from 'reactstrap';

import Alert from 'app/components/general/Alert';
import PaymentCard from 'app/components/matches/PaymentCard';
import { ICartLineItem } from 'app/ducks/cart/types';
import validateInput from './CartVariableValidator';
import InputGroupBlock from 'app/components/general/InputGroupBlock';



interface ICartVariableComponentProps {
  matchCardData: {
    round: string;
    dateTime: string;
    eventInfo: string;
    amount: string;
    section: string;
    time: string;
    location: string;
    status: string;
    otherTeamStatus: string;
    statuses: [
      {
        colour: string;
        text: string;
      }
    ];
  };
  groupName: string;
  matchPaymentId: string;
  totalAmount: number;
  totalRawAmount: number;
  totalQuantity: number;
  minAmount: number;
  updateCart: any;
  additionalPayment: boolean;
  defaultLineItems: ICartLineItem[];
  lineItems: ICartLineItem[];
  currentMatchPayment: any;
}

export default class CartVariableComponent extends React.Component<
  ICartVariableComponentProps,
  {}
> {
  static defaultProps: ICartVariableComponentProps = {
    matchCardData: {
      round: undefined,
      dateTime: undefined,
      eventInfo: undefined,
      amount: undefined,
      section: undefined,
      time: undefined,
      location: undefined,
      statuses: undefined,
      status: undefined,
      otherTeamStatus: undefined,
    },
    groupName: undefined,
    matchPaymentId: undefined,
    totalAmount: undefined,
    totalRawAmount: undefined,
    totalQuantity: undefined,
    minAmount: undefined,
    updateCart: undefined,
    defaultLineItems: [],
    lineItems: [],
    additionalPayment: false,
    currentMatchPayment: undefined,
  };

  continueToPayment = () => {
    history.push(`/payment/match/${this.props.matchPaymentId}/pay`);
  };

  handleBooleanChange = (lineItem) => {
    const updatedState = {
      minAmount: this.props.minAmount,
      lineItems: {
        ...this.props.lineItems,
        [lineItem.code]: {
          value: !lineItem.value,
          quantity: !lineItem.value ? 1 : 0,
          amount: lineItem.amount,
          description: lineItem.description,
          disabled: lineItem.disabled,
          min: lineItem.min,
          max: lineItem.max,
          noUnit: lineItem.noUnit,
          lineItemType: lineItem.lineItemType,
          code: lineItem.code,
        },
      },
    };
    this.props.updateCart(updatedState);
  };

  handleValueChange = (e, lineItem) => {
    const updatedState = {
      minAmount: this.props.minAmount,
      lineItems: {
        ...this.props.lineItems,
        [lineItem.code]: {
          value: e.target.value,
          amount: lineItem.amount,
          description: lineItem.description,
          disabled: lineItem.disabled,
          min: lineItem.min,
          max: lineItem.max,
          noUnit: lineItem.noUnit,
          lineItemType: lineItem.lineItemType,
          code: lineItem.code,
        },
      },
    };
    this.props.updateCart(updatedState);
  };
  handleQuantityChange = (e, lineItem) => {
    if (e.target.value >= 0 && e.target.value <= 200) {
      const updatedState = {
        minAmount: this.props.minAmount,
        lineItems: {
          ...this.props.lineItems,
          [lineItem.code]: {
            defaultQuantity: this.props.lineItems[lineItem.code].defaultQuantity,
            quantity: parseInt(e.target.value),
            amount: lineItem.amount,
            disabled: lineItem.disabled,
            description: lineItem.description,
            min: lineItem.min,
            max: lineItem.max,
            noUnit: lineItem.noUnit,
            lineItemType: lineItem.lineItemType,
            code: lineItem.code,
          },
        },
      };
      this.props.updateCart(updatedState);
    }
  };

  renderLineItem = (lineItem): React.ReactNode => {
    if (lineItem.lineItemType === undefined || lineItem.lineItemType === "number") {
      return (<div key={lineItem.description}>
        <div className="row">
          <div className="col col-8 text-dark-grey d-flex">
            <div>
              <Input
                className="cart-number-input"
                name="quantity"
                autoFocus
                type="number"
                disabled={lineItem.disabled}
                min={lineItem.min}
                max={lineItem.max}
                pattern="\d*"
                value={lineItem.quantity}
                onChange={(e) => this.handleQuantityChange(e, lineItem)}
              />
            </div>
            <div className="d-flex justify-content-center align-items-center">
              {lineItem.description} ({`${parseAmount(lineItem.amount)} ${_.isEmpty(lineItem?.unitLabel) ? "per person" : lineItem.unitLabel}`})
            </div>
          </div>
          <div className="col col-4 d-flex justify-content-end text-right text-dark-grey align-items-center">
            {parseAmount(lineItem.quantity * lineItem.amount)}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div>
      </div>)
    }
    if (lineItem.lineItemType === "static") {
      return (<div key={lineItem.description}>
        <div className="row">
          <div className="col col-8 text-dark-grey d-flex">
            <div className="d-flex justify-content-center align-items-center">
              {lineItem.description}
            </div>
          </div>
          <div className="col col-4 d-flex justify-content-end text-right text-dark-grey align-items-center">
            {parseAmount(lineItem.quantity * lineItem.amount)}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div>
      </div>)
    }
    if (lineItem.lineItemType === "string") {
      return (<div key={lineItem.description}>
        <div className="row">
          <div className="col col-8 text-dark-grey d-flex">
            <div>
              <Input
                className="cart-number-input"
                name="value"
                autoFocus
                type="text"
                disabled={lineItem.disabled}
                pattern="\d*"
                value={lineItem.value}
                onChange={(e) => this.handleValueChange(e, lineItem)}
              />
            </div>
            <div className="d-flex justify-content-center align-items-center">
              {lineItem.description} ({`${parseAmount(lineItem.amount)}${!lineItem.noUnit ? " per person" : ""}`})
            </div>
          </div>
          <div className="col col-4 d-flex justify-content-end text-right text-dark-grey align-items-center">
            {parseAmount(lineItem.quantity * lineItem.amount)}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div>
      </div>)
    }
    if (lineItem.lineItemType === "boolean") {
      return (<div key={lineItem.description}>
        <div className="row">
          <div className="col col-8 text-dark-grey d-flex">
            <div>
              <InputGroupBlock
                name="value"
                type="boolean"
                disabled={lineItem.disabled}
                radio
                value={lineItem.value}
                onChange={(e) => this.handleBooleanChange(lineItem)}
              />
            </div>
            <div className="d-flex justify-content-center align-items-center">
              {lineItem.description} ({`${parseAmount(lineItem.amount)}${!lineItem.noUnit ? " per person" : ""}`})
            </div>
          </div>
          <div className="col col-4 d-flex justify-content-end text-right text-dark-grey align-items-center">
            {parseAmount(lineItem.quantity * lineItem.amount)}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div>
      </div>)
    }
  }

  renderLineItems = () => _.map(
    _.orderBy(this.props.lineItems, (item) => -1 * (item.defaultQuantity || 0)),
    (lineItem) => (
      this.renderLineItem(lineItem)
    ),
  );

  isValid() {
    const { errors, isValid } = validateInput(this.props.totalQuantity);

    return isValid;
  }

  render(): React.ReactNode {
    const lessThanMin = this.props.totalRawAmount < this.props.minAmount;
    return (
      <div>
        {!_.isEmpty(this.props.matchCardData) && (
          <div className="row">
            <div className="col">
              <PaymentCard {...this.props.matchCardData} truncated />
            </div>
          </div>
        )}
        <div className="row with-margin-top">
          <div className="col">
            <Card>
              <CardBody className="with-extra-padding">
                <div className="row">
                  <div className="col">
                    {!this.props.additionalPayment && (<h3 className="text-black">Payment Summary</h3>)}
                    {this.props.additionalPayment && (<h3 className="text-black">Pay for extra player/s</h3>)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col text-dark-grey">
                    <span className="text-weight-medium-bold">Team: </span>
                    {this.props.groupName}
                  </div>
                </div>
                {this.props.additionalPayment && (<div className="row with-margin-top-10">
                  <div className="col text-dark-grey">
                    <span className="text-weight-medium-bold">Previously paid: </span>
                    <span className="text-weight-medium">{parseAmount(this.props.currentMatchPayment.matchPayment.amount)}</span>
                    <span> for {this.props.currentMatchPayment?.matchPayment?.noOfRegularPlayers} regular players</span>
                    {this.props.currentMatchPayment?.matchPayment?.noOfFillInPlayers === 1 && (<span>, {this.props.currentMatchPayment?.matchPayment?.noOfFillInPlayers} fill-in player</span>)}
                    {this.props.currentMatchPayment?.matchPayment?.noOfFillInPlayers > 1 && (<span>, {this.props.currentMatchPayment?.matchPayment?.noOfFillInPlayers} fill-in players</span>)}
                  </div>
                </div>)}
                {/* <div className="row with-margin-top">
                  <div className="col text-black text-weight-medium-bold">
                    Select the number of players below:
                  </div>
                </div> */}
                <div className="row">
                  <div className="col">
                    <div className="divider full" />
                  </div>
                </div>
                {this.renderLineItems()}
                <div className="row">
                  <div className="col text-black text-weight-medium-bold">
                    Total Amount
                  </div>
                  <div className="col text-right text-dark-grey text-weight-medium-bold">
                    {parseAmount(this.props.totalAmount)}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        {lessThanMin && (
          <div className="row with-margin-top">
            <div className="col">
              <Alert>
                The minimum amount for this payment is
                {' '}
                {parseAmount(this.props.minAmount)}
              </Alert>
            </div>
          </div>
        )}
        <div className="row with-margin-top">
          <div className="col text-right">
            <Button
              className="btn-success"
              type="submit"
              disabled={!this.isValid()}
              onClick={this.continueToPayment}
            >
              Continue to Pay
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
